export function uiSrefRemoveOriginal($provide) {
	'ngInject';
	$provide.decorator('uiSrefDirective', $delegate => {
		'ngInject';
		// $delegate is array of all ui-sref directives that were registered
		// only keep ours
		return $delegate.filter(del => del.$$moduleName == 'sh.uiSref');
	});
}
